"use strict";
module.exports = {
    entityModel: 'outgoingMessage',
    events: {
        OUTGOING_MESSAGE_CREATED: 'OUTGOING_MESSAGE_CREATED',
        OUTGOING_MESSAGE_UPDATED: 'OUTGOING_MESSAGE_UPDATED',
        OUTGOING_MESSAGE_RESENT: 'OUTGOING_MESSAGE_RESENT',
    },
    actions: {
        get: 'v1.outgoingMessage.get',
        list: 'v1.outgoingMessage.list',
        writeFtpFile: 'v1.outgoingMessage.writeFtpFile',
        resendEvent: 'v1.outgoingMessage.resendEvent',
        writeOutgoingIntegrationMessage: 'v1.outgoingMessage.writeOutgoingIntegrationMessage',
        writeOutgoingMessage: 'v1.outgoingMessage.writeOutgoingMessage',
        upsert: 'v1.outgoingMessage.upsert',
        upsertWhenEmpty: 'v1.outgoingMessage.upsertWhenEmpty',
        updateWhenEmpty: 'v1.outgoingMessage.updateWhenEmpty',
        update: 'v1.outgoingMessage.update',
    },
    statuses: {
        error: 'error',
        resolved: 'resolved',
        success: 'success',
    },
};
